var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-gallery"
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true
        },
        on: {
          showEdit: _vm.showEdit,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.closeEdit
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _vm.files.length !== 0
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-block-gallery-content",
                          style: {
                            "max-height": _vm.currentHeight + "px"
                          }
                        },
                        [
                          _vm._l(_vm.files, function(image, index) {
                            return _c(
                              "div",
                              {
                                key: image.id,
                                ref: "images",
                                refInFor: true,
                                staticClass:
                                  "cw-block-gallery-slides cw-block-gallery-fade"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "cw-block-gallery-number-text"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(index + 1) +
                                        " / " +
                                        _vm._s(_vm.files.length)
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("img", {
                                  style: {
                                    "max-height": _vm.currentHeight + "px"
                                  },
                                  attrs: {
                                    src: image.meta["download-url"]
                                  },
                                  on: {
                                    load: function load($event) {
                                      if (_vm.files.length - 1 === index) {
                                        _vm.startGallery()
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _vm.currentShowFileNames === "true"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cw-block-gallery-file-name"
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(image.attributes.name))
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm.currentNav === "true"
                            ? _c("div", [
                                _c("button", {
                                  staticClass: "cw-block-gallery-prev",
                                  attrs: {
                                    title: _vm.$gettext("Vorheriges Bild")
                                  },
                                  on: {
                                    click: function click($event) {
                                      return _vm.plusSlides(-1)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("button", {
                                  staticClass: "cw-block-gallery-next",
                                  attrs: {
                                    title: _vm.$gettext("Nächstes Bild")
                                  },
                                  on: {
                                    click: function click($event) {
                                      return _vm.plusSlides(1)
                                    }
                                  }
                                })
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e()
                ]
              },
              proxy: true
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Ordner")]),
                              _vm._v(" "),
                              _c("courseware-folder-chooser", {
                                attrs: {
                                  allowUserFolders: ""
                                },
                                model: {
                                  value: _vm.currentFolderId,
                                  callback: function callback($$v) {
                                    _vm.currentFolderId = $$v
                                  },
                                  expression: "currentFolderId"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Maximale Höhe")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentHeight,
                                    expression: "currentHeight"
                                  }
                                ],
                                attrs: {
                                  type: "number",
                                  min: "0",
                                  max: "800"
                                },
                                domProps: {
                                  value: _vm.currentHeight
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.currentHeight = $event.target.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Autoplay")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentAutoplay,
                                      expression: "currentAutoplay"
                                    }
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.currentAutoplay = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "true"
                                      }
                                    },
                                    [_c("translate", [_vm._v("Ja")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "false"
                                      }
                                    },
                                    [_c("translate", [_vm._v("Nein")])],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.currentAutoplay === "true"
                            ? _c(
                                "label",
                                [
                                  _c("translate", [
                                    _vm._v("Autoplay Timer in Sekunden")
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.currentAutoplayTimer,
                                        expression: "currentAutoplayTimer"
                                      }
                                    ],
                                    attrs: {
                                      type: "number",
                                      min: "1",
                                      max: "60"
                                    },
                                    domProps: {
                                      value: _vm.currentAutoplayTimer
                                    },
                                    on: {
                                      input: function input($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.currentAutoplayTimer =
                                          $event.target.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentAutoplay === "true"
                            ? _c(
                                "label",
                                [
                                  _c("translate", [_vm._v("Navigation")]),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.currentNav,
                                          expression: "currentNav"
                                        }
                                      ],
                                      on: {
                                        change: function change($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.currentNav = $event.target
                                            .multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value: "true"
                                          }
                                        },
                                        [_c("translate", [_vm._v("Ja")])],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value: "false"
                                          }
                                        },
                                        [_c("translate", [_vm._v("Nein")])],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Dateinamen anzeigen")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentShowFileNames,
                                      expression: "currentShowFileNames"
                                    }
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.currentShowFileNames = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "true"
                                      }
                                    },
                                    [_c("translate", [_vm._v("Ja")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "false"
                                      }
                                    },
                                    [_c("translate", [_vm._v("Nein")])],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  },
                  proxy: true
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c(
                    "p",
                    [
                      _c("translate", [
                        _vm._v("Informationen zum Galerie-Block")
                      ])
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }